<template>
  <div class="upload-dropzone" :class="{'is-active': !file}">
    <div v-if="!file" class="upload-dropzone--text">
      <div class="upload-dropzone--icon">
        <!-- <img :src="upload_icon" alt=""> -->
      </div>
      <p>
        {{$t('ui.upload.dropzone_message')}}
      </p>
    </div>
    <div v-if="file" class="upload-dropzone--text">
      {{file.name}} / {{formatBytes(file.size,2)}} <i @click="emptyFile" class="icon icon-x" :title="$t('ui.upload.empty_file')"></i>
    </div>
    <input v-if="!file" type="file" @change="fileUpload" id="file">
  </div>
</template>
<script>
import upload_icon from '@/assets/icons/icon-upload.svg'

export default{
  data(){
    return {
      file: null,
      upload_icon
    }
  },
  methods: {
    fileUpload(e){
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return
      this.file = files[0]
      this.$emit('change', this.file)
    },
    emptyFile(){
      this.file = null
      this.$emit('change', null)
    },
    formatBytes(bytes,decimals) {
      if(bytes == 0) return '0 Bytes';
      var k = 1024,
      dm = decimals || 2,
      sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }
  }
}
</script>
<style lang="sass" scoped>
.upload-dropzone--text
  font-size: 1.2em
  text-align: center
  padding: 50px 0
  p
    display: inline-block
    margin-bottom: 0px
    color: $sensual

.upload-dropzone
  margin-top: 15px
  outline: 2px dashed $paper-dark
  background: transparent
  padding: 0px 10px
  position: relative
  cursor: pointer
  margin: 20px 0px
  input[type=file]
    opacity: 0
    width: 100%
    top: 0
    bottom: 0
    position: absolute
    cursor: pointer

  &.is-active:hover
    outline: 2px dashed $sensual
    .upload-dropzone--text
      color: $sensual
</style>



// WEBPACK FOOTER //
// UploadField.vue?4837cb78